<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Properties {
    /** Chip children — typically one or more `<Chip>` spans. */
    children: Snippet;
  }

  const { children }: Properties = $props();
</script>

<!-- Horizontal chip container used above the departures board and route
     results. Shared so every board reads with the same rhythm. -->
<div class="chip-strip">
  {@render children()}
</div>

<style>
  .chip-strip {
    display: flex;
    gap: var(--space-xs);
    margin-bottom: var(--space-sm);
  }
</style>
